import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

// Fetch media with pagination support
export const fetchMedia = createAsyncThunk(
  "media/fetch",
  async (page = 1, thunkAPI) => {
    try {
      const res = await api.get(`/dashboard/uploads?type=image&per_page=20&page=${page}`);
      return res.data.data.uploads; // paginator object with data, current_page, etc.
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch media");
    }
  }
);

// Upload media with progress tracking
export const uploadMedia = createAsyncThunk(
  "media/upload",
  async ({ file, onProgress, controller }, thunkAPI) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post("/dashboard/uploads", formData, {
        signal: controller?.signal,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (typeof onProgress === "function") {
            onProgress(percent);
          }
        },
      });
      return res.data.data.upload;
    } catch (error) {
      if (api.isCancel?.(error) || error.name === "CanceledError") {
        return thunkAPI.rejectWithValue("Upload canceled");
      }
      return thunkAPI.rejectWithValue("Upload failed");
    }
  }
);

const mediaSlice = createSlice({
  name: "media",
  initialState: {
    items: [],
    loading: false,
    error: null,
    page: 1,
    currentPage: 1,
    lastPage: 1,
  },
  reducers: {
    resetMediaState: (state) => {
      state.items = [];
      state.loading = false;
      state.error = null;
      state.page = 1;
      state.currentPage = 1;
      state.lastPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMedia.fulfilled, (state, action) => {
        const response = action.payload;
        const newItems = response?.data || [];
        state.items = [...state.items, ...newItems];
        state.currentPage = response.current_page;
        state.lastPage = response.last_page;
        state.loading = false;
      })
      .addCase(fetchMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      });
  },
});

export const { resetMediaState } = mediaSlice.actions;
export default mediaSlice.reducer;
